import { Injectable, inject } from '@angular/core';

import { INativePrice, NativePrice } from './native-price';
import { NativePriceFormatterService } from './native-price-formatter.service';

@Injectable({ providedIn: 'root' })
export class ExternalPriceFormatterService {
    private nativeFormatter = inject(NativePriceFormatterService);

    /**
     * Converts a price object of type `INativePrice` to an instance of NativePrice and format it with NativePriceFormatter, according to the specified user format.
     *
     * @param  nativePrice - The input price of type `INativePrice` that needs to be converted.
     * @returns  - The formatted price string.
     */
    format(nativePrice: INativePrice | null | undefined) {
        const price = NativePrice.fromNativePrice(nativePrice || {});

        return this.nativeFormatter.format(price);
    }
}
